import * as TypeGraphQL from "type-graphql";
export var AlpacaAccountScalarFieldEnum;
(function (AlpacaAccountScalarFieldEnum) {
    AlpacaAccountScalarFieldEnum["id"] = "id";
    AlpacaAccountScalarFieldEnum["type"] = "type";
    AlpacaAccountScalarFieldEnum["APIKey"] = "APIKey";
    AlpacaAccountScalarFieldEnum["APISecret"] = "APISecret";
    AlpacaAccountScalarFieldEnum["configuration"] = "configuration";
    AlpacaAccountScalarFieldEnum["marketOpen"] = "marketOpen";
    AlpacaAccountScalarFieldEnum["realTime"] = "realTime";
    AlpacaAccountScalarFieldEnum["cryptoTradingEnabled"] = "cryptoTradingEnabled";
    AlpacaAccountScalarFieldEnum["cryptoTradingPairs"] = "cryptoTradingPairs";
    AlpacaAccountScalarFieldEnum["cryptoTradeAllocationPct"] = "cryptoTradeAllocationPct";
    AlpacaAccountScalarFieldEnum["tradeAllocationPct"] = "tradeAllocationPct";
    AlpacaAccountScalarFieldEnum["autoAllocation"] = "autoAllocation";
    AlpacaAccountScalarFieldEnum["minPercentageChange"] = "minPercentageChange";
    AlpacaAccountScalarFieldEnum["volumeThreshold"] = "volumeThreshold";
    AlpacaAccountScalarFieldEnum["enablePortfolioTrailingStop"] = "enablePortfolioTrailingStop";
    AlpacaAccountScalarFieldEnum["portfolioTrailPercent"] = "portfolioTrailPercent";
    AlpacaAccountScalarFieldEnum["portfolioProfitThresholdPercent"] = "portfolioProfitThresholdPercent";
    AlpacaAccountScalarFieldEnum["reducedPortfolioTrailPercent"] = "reducedPortfolioTrailPercent";
    AlpacaAccountScalarFieldEnum["defaultTrailingStopPercentage100"] = "defaultTrailingStopPercentage100";
    AlpacaAccountScalarFieldEnum["firstTrailReductionThreshold100"] = "firstTrailReductionThreshold100";
    AlpacaAccountScalarFieldEnum["secondTrailReductionThreshold100"] = "secondTrailReductionThreshold100";
    AlpacaAccountScalarFieldEnum["firstReducedTrailPercentage100"] = "firstReducedTrailPercentage100";
    AlpacaAccountScalarFieldEnum["secondReducedTrailPercentage100"] = "secondReducedTrailPercentage100";
    AlpacaAccountScalarFieldEnum["minimumPriceChangePercent100"] = "minimumPriceChangePercent100";
    AlpacaAccountScalarFieldEnum["userId"] = "userId";
    AlpacaAccountScalarFieldEnum["createdAt"] = "createdAt";
    AlpacaAccountScalarFieldEnum["updatedAt"] = "updatedAt";
})(AlpacaAccountScalarFieldEnum || (AlpacaAccountScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AlpacaAccountScalarFieldEnum, {
    name: "AlpacaAccountScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AlpacaAccountScalarFieldEnum.js.map